/**
 * 汎用モーダルを実行するクラス
 * data-common-modal属性を持つ要素単位で動作
 */

export default class CommonModal {
  constructor() {
    this.modals = document.querySelectorAll('[data-common-modal]');
    this.modalOpenClass = 'is-open';
    this.bodyFixedClass = 'is-modal-open';
    this.scrollPosition = 0;
    this.currentOpenModal = null; // 現在開いているモーダルを追跡
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
  }

  /**
   * ESCキーでモーダルを閉じる
   */
  handleKeyDown(ev) {
    if (ev.key === 'Escape') {
      this.closeAll();
    }
  }

  /**
   * モーダルが開いている間のスクロールを防止
   * ただし、モーダル内のdata-body要素内でのスクロールは許可
   */
  handleTouchMove(ev) {
    // 現在開いているモーダル内のdata-body要素内でのスクロールは許可
    if (this.currentOpenModal) {
      const modalBody = this.currentOpenModal.querySelector('[data-body]');
      if (modalBody && modalBody.contains(ev.target)) {
        return;
      }
    }
    // それ以外のスクロールは防止
    ev.preventDefault();
  }

  /**
   * モーダルを開く
   * @param {HTMLElement} modal - 開くモーダル要素
   * @param {string} key - モーダルのキー（将来実装予定）
   */
  open(modal, key) {
    // 将来実装予定
    // 起動ボタンとdata-common-modalの値を紐づけて開く処理を実装
    if (!modal) return;

    // 現在のスクロール位置を保存
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // bodyを固定
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.classList.add(this.bodyFixedClass);

    // 現在開いているモーダルを記録
    this.currentOpenModal = modal;

    // タッチイベントでスクロールを防止
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });

    // ESCキーで閉じる
    document.addEventListener('keydown', this.handleKeyDown);

    // モーダルを表示
    modal.classList.add(this.modalOpenClass);
  }

  /**
   * モーダルを閉じる
   * @param {HTMLElement} modal - 閉じるモーダル要素
   */
  close(modal) {
    if (!modal) return;

    // bodyの固定を解除
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove(this.bodyFixedClass);

    // スクロール位置を復元
    window.scrollTo(0, this.scrollPosition);

    // イベントリスナーを削除
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.removeEventListener('keydown', this.handleKeyDown);

    // 現在開いているモーダルをクリア
    this.currentOpenModal = null;

    // モーダルを非表示
    modal.classList.remove(this.modalOpenClass);
  }

  /**
   * すべてのモーダルを閉じる
   */
  closeAll() {
    this.modals.forEach((modal) => {
      if (modal.classList.contains(this.modalOpenClass)) {
        this.close(modal);
      }
    });
  }

  /**
   * 指定されたキーに対応するモーダルを取得
   * @param {string} key - モーダルのキー
   * @returns {HTMLElement|null} モーダル要素
   */
  getModalByKey(key) {
    return document.querySelector(`[data-common-modal="${key}"]`);
  }

  init() {
    if (!this.modals.length) return;

    // 各モーダルの背景と閉じるボタンのイベント
    this.modals.forEach((modal) => {
      const bg = modal.querySelector('[data-bg]');
      const closeButton = modal.querySelector('[data-close]');

      // 背景をクリックしたときに閉じる
      if (bg) {
        bg.addEventListener('click', () => {
          this.close(modal);
        });
      }

      // 閉じるボタンをクリックしたときに閉じる
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.close(modal);
        });
      }

      // モーダル本体をクリックしたときは閉じない（イベント伝播を止める）
      const modalBody = modal.querySelector('[data-body]');
      if (modalBody) {
        modalBody.addEventListener('click', (ev) => {
          ev.stopPropagation();
        });
      }

      // is-openクラスがついていたら自動的に開く
      if (modal.classList.contains(this.modalOpenClass)) {
        this.open(modal);
      }
    });
  }
}

